import '@modifi/client-polyfills'
import React from 'react'
import {createRoot} from 'react-dom/client'

import getApp from './App'

const config = {
  useSuspense: true,
  plugins: {
    i18n: {
      react: {
        useSuspense: true,
      },
    },
  },
}

getApp(config).then(App => {
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
})
